<template lang="pug">
    div(id="app")
        v-app
            router-view

            // Snacknar (popup notifications)
            snackbar-component
</template>

<script>
    import { Snackbar } from '~components';

    export default {
        components: {
            SnackbarComponent: Snackbar,
        },
    };
</script>

<style lang="stylus" scoped>
    #app
        background-color: rgba(lightgrey, 0.08)
</style>
